<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-data-line"></span> 舆情
            </span>
        </div>
        <div v-if="data" class="content">
            <el-row :gutter="20" class="auditTotalNum">
                <el-col :sm="8">
                    <el-card shadow="never">
                        <router-link :to="`/opinion/suggest/list`">
                            <div class="title">乐迷咨询</div>
                            <div class="num clearfix">
                                <b>{{data.fansPendingTotalNum || 0}}</b> 当前待处理
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
                <el-col :sm="8">
                    <el-card shadow="never">
                        <router-link :to="`/operation/comment/list?mainType=6&rangeStart=${intervalData.startTime} 00:00:00&rangeEnd=${intervalData.endTime} 23:59:59`">
                            <div class="title">演出总评论</div>
                            <div class="num clearfix">
                                <b>{{data.activityLetterTotalNum || 0}}</b>
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
                <el-col :sm="8">
                    <el-card shadow="never">
                        <router-link :to="`/operation/comment/list?mainType=8&rangeStart=${intervalData.startTime} 00:00:00&rangeEnd=${intervalData.endTime} 23:59:59`">
                            <div class="title">众筹总评论</div>
                            <div class="num clearfix">
                                <b>{{data.raiseLetterTotalNum || 0}}</b>
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
            </el-row>

            <el-tabs v-model="activeName"  @tab-click="clickTab" class="MT10">
                <el-tab-pane label="乐迷咨询" name="1"></el-tab-pane>
                <el-tab-pane label="演出总评论" name="2"></el-tab-pane>
                <el-tab-pane label="众筹总评论" name="3"></el-tab-pane>
            </el-tabs>
            
            <div class="data-box">
                <div class="total">
                    {{activeName == 1 ? '乐迷咨询:' : activeName == 2 ? '演出总评论:' : '众筹总评论:' }} 
                    <b>{{data && data.totalNumSum}} </b> 
                    <router-link v-if="activeName == 1" class="color-theme" :to="`/opinion/suggest/list?handerType=0&fbBeginTime=${intervalData.startTime} 00:00:00&fbEndTime=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                    <router-link v-if="activeName == 2" class="color-theme" :to="`/operation/comment/list?mainType=6&rangeStart=${intervalData.startTime} 00:00:00&rangeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                    <router-link v-if="activeName == 3" class="color-theme" :to="`/operation/comment/list?mainType=8&rangeStart=${intervalData.startTime} 00:00:00&rangeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                </div>
                <div id="opinionDataChart" ref="opinionDataChart"></div>
            </div>
        </div>
    </el-card>
</template>

<script>
import { Chart } from '@antv/g2';


export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange:{
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            dataLoading: false,
            data: null,
            activeName: "1",
            chart: null,
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: this.activeName == 1 ? "/dashboard/fanssuggest" : this.activeName == 2 ? "/dashboard/activityletter" : "/dashboard/raiseletter",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;

                        this.$nextTick(() => {
                            this.drawChart();
                        })
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        clickTab(){
            this.getData();
        },
        drawChart(){
            if( this.chart ) this.chart.destroy();
            let _data = [];
            const _dataArry = [...this.data.totalNumChart.lineSeriesData];

            _dataArry.map( item => {
                _data.push({
                    name: item.name,
                    value: parseFloat(item.value)
                })
            })
            
            this.chart = new Chart({
                container: 'opinionDataChart',
                autoFit: true,
                height: 400,
            });
            this.chart.data(_data);

            if( _dataArry.length > 7 ){
                this.chart.option('slider', {
                    start: (_dataArry.length - 7) / _dataArry.length,
                    end: 1,
                });
            }

            this.chart.tooltip({
                showTitle: false,
                showMarkers: false,
                showCrosshairs: true,
            });
            
            this.chart
                .line()
                .position('name*value')
                .shape('smooth')
                .tooltip('name*value', (name, value) => {
                    // value = this.activeName == 1 ? parseFloat(value).toFixed(2) : value;
                    return {
                        name: name,
                        value: value,
                    };
                });

            this.chart.render();
        }
    }
}
</script>

<style lang="scss" scoped>
.total{
    margin:10px 0 25px 0;
    b{
        font-size: 18px;
        font-weight: 700;
    }
}
.auditTotalNum{
    .num{
        margin-top: 10px;
        color: $--color-info;
        b{
            font-weight: 700;
            font-size: 16px;
            color: $--color-theme;
        }
    }
}
</style>